<!--
    描述：新增、编辑、查看人员
    时间：2021-06-22
    Created by 王帅
-->
<template>
	<el-form ref="userForm"
			 :model="userForm"
			 :rules="userRules"
			 label-width="120px">
		<el-row :gutter="20">
			<el-col :span="12">
				<el-form-item label="姓名"
							  prop="sname">
					<el-input v-model="userForm.sname"
							  :disabled="isDisabled"
							  placeholder="请输入"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="用户名"
							  prop="username">
					<el-input v-model="userForm.username"
							  :disabled="isDisabled"
							  placeholder="请输入"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="12">
				<el-form-item label="手机号"
							  prop="phone">
					<el-input v-model="userForm.phone"
							  :disabled="isDisabled"
							  placeholder="请输入"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="身份证号码"
							  prop="idCard">
					<el-input v-model="userForm.idCard"
							  :disabled="isDisabled"
							  placeholder="请输入"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="12">
				<el-form-item label="性别"
							  prop="sex">
					<el-radio v-model="userForm.sex"
							  :label="1"
							  disabled>男</el-radio>
					<el-radio v-model="userForm.sex"
							  :label="0"
							  disabled>女</el-radio>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="民族"
							  prop="nation">
					<el-select v-model="userForm.nation"
							   :disabled="isDisabled">
						<el-option v-for="(item, index) in mz"
								   :key="'民族' + index"
								   :label="item.sname"
								   :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="12">
				<el-form-item label="出生日期"
							  prop="birthDate">
					<el-date-picker v-model="userForm.birthDate"
									type="date"
									disabled
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="年龄"
							  prop="age">
					<el-input disabled
							  v-model="userForm.age"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="12">
				<el-form-item label="角色"
							  prop="roleIds">
					<el-select v-model="userForm.roleIds"
							   multiple
							   :disabled="isDisabled"
							   placeholder="请选择">
						<el-option v-for="(item, index) in roleTreeData"
								   :key="'角色' + index"
								   :label="item.label"
								   :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="12">
				<el-form-item label="数据角色"
							  prop="dataRoleId">
					<el-select v-model="userForm.dataRoleId"
							   placeholder="请选择"
							   clearable>
						<el-option v-for="item in roleList"
								   :key="item.id"
								   :label="item.roleName"
								   :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-col>
			<!--            <el-col :span="12">
                <el-form-item label="账户状态" prop="orEnable">
                    <vxe-switch
                            v-model="userForm.orEnable"
                            :disabled="isDisabled"
                            open-label="启用"
                            open-value="1"
                            close-label="禁用"
                            :close-value="0"
                    ></vxe-switch>
                </el-form-item>
            </el-col>-->
		</el-row>
	</el-form>
</template>

<script>
import { mapState } from 'vuex'
import { getOneInfo, updateTenantUser } from 'api/system/user.js'
import { selectRoleTree } from 'api/system/role.js'
import { getDictsByValue } from 'api/system/group.js'
import { getInfoById } from 'utils/tools'
import { selectDataRole } from '@/api/system/DataRole'

export default {
	name: '',
	props: {
		// 类型
		mode: {
			type: String,
			default: 'add',
		},

		// 当前信息
		currentRow: {
			type: Object,
			default: () => {
				return {}
			},
		},

		// 是否编辑回显
		userId: {
			type: String,
			default: '',
		},

		tenantInfo: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			// 人员信息表
			userForm: {
				sname: '',
				username: '',
				phone: '',
				idCard: '',
				sex: '',
				nation: '',
				birthDate: '',
				age: '',
				position: '',
				role: '',
				roleIds: [],
				orEnable: '',
				dataRoleId: '',
			},
			userRules: {
				sname: [{ required: true, message: '请输入姓名' }],
				username: [{ required: true, message: '请输入用户名' }],
				phone: [
					{ required: true, message: '请输入手机号' },
					{
						pattern: /^1[3-9][0-9]{9}$/,
						message: '手机号码格式不正确，请重新输入',
					},
				],
				idCard: [
					{
						pattern:
							/^[1-9][0-9]{5}(18|19|(2[0-9]))[0-9]{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)[0-9]{3}[0-9Xx]$/,
						message: '身份证输入有误',
					},
				],
			},
			roleTreeData: [], // 角色
			stationList: [], // 岗位列表
			unitList: [],
			roleList: [], //数据角色列表
		}
	},
	created() {
		if (this.userId && this.userId !== '') {
			this.getUserInfo()
		}
		this.getStationList()
		// 获取数据角色列表
		this.getRoleList()
	},
	methods: {
		// 获取数据角色列表
		getRoleList() {
			let currentRow = JSON.parse(this.$getSessionItem('currentRowDw'))
			selectDataRole({}).then((res) => {
				this.roleList = res.data
			})
		},

		// 获取个人信息
		getUserInfo() {
			let param = {}
			param.tenantId = this.tenantInfo.id
			param.limitId = this.tenantInfo.limitId
			param.id = this.userId
			getOneInfo(param)
				.then((res) => {
					this.userForm = res.data.sysUser
				})
				.catch((err) => {})
		},

		// 获取角色数据
		getRoleData() {
			let param = {}
			param.limitId = this.tenantInfo.limitId
			selectRoleTree(param).then((res) => {
				this.roleTreeData = res.data
			})
		},

		//获取岗位
		getStationList() {
			let param = {}
			param.value = '1002'
			getDictsByValue(param).then((res) => {
				this.stationList = res.data
			})
		},

		// 保存方法
		returnUserInfo() {
			let that = this
			return new Promise((resolve, reject) => {
				that.$refs.userForm.validate((valid) => {
					if (valid) {
						that.userForm.tenantId = that.tenantInfo.id
						that.userForm.limitId = that.tenantInfo.limitId
						updateTenantUser(that.userForm)
							.then((res) => {
								resolve(true)
							})
							.catch((err) => {
								reject(false)
							})
					} else {
						resolve(false)
					}
				})
			})
		},
	},
	beforeDestroy() {
		this.$refs.userForm.resetFields()
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo,
			roleType: (state) => state.userInfo.roleType, // 1 是超级管理员  0 是普通
		}),

		...mapState('dict', {
			mz: (state) => state.projectDict.mz,
			rygw: (state) => state.projectDict.rygw,
		}),

		// 是否可编辑
		isDisabled() {
			return this.type === 'view'
		},
	},
	watch: {
		currentRow: {
			handler: function (obj) {
				if (obj.id) {
					this.userForm = this.$utils.clone(this.currentRow, true)
				}
			},
			deep: true,
		},

		// 监听身份证的输入，计算出生日期 和 年龄
		'userForm.idCard': {
			handler: function (val) {
				// console.log(this)
				let dateInfo = getInfoById(val)
				if (dateInfo.age) {
					this.userForm.age = dateInfo.age
					this.userForm.birthDate = dateInfo.birthDate
					this.userForm.sex = dateInfo.sex
				} else {
					this.userForm.age = ''
					this.userForm.birthDate = ''
					this.userForm.sex = ''
				}
			},
			deep: true,
		},
	},
}
</script>

<style scoped lang="less"></style>
